const local = {
  notifications: []
};

const notificationStack = new EventTarget();

Object.assign(notificationStack, {
  // Retrieve all notifications

  // Push a new notification onto the stack
  pushNotification: (type, message) => {
    const notification = { type, message };
    local.notifications.push(notification);
    notificationStack.dispatchEvent(new Event('messaging:notification-pushed'));
    return notification;
  },

  // Pop the latest notification off the stack
  popNotification: () => {
    const poppedNotification = local.notifications.pop();
    return poppedNotification;
  },

  // Clear all notifications
  clearNotifications: () => {
    const clearedNotifications = [...local.notifications];
    local.notifications = [];

    return clearedNotifications;
  }
});

export default notificationStack;
